
import Footer from '../../TheamLayout/Footer';
import Header from '../../TheamLayout/Header';
import Main from './Main'

const Home = () => {
  return <>
   <Header/>
  <Main/>
  <Footer/>
  </>;
};

export default Home;
